
import dayjs from 'dayjs';

export const hasDateTimeChanged = (dateTime1: string, dateTime2: string) => {
  return !dayjs(dateTime1).isSame(dayjs(dateTime2));
};
